<template lang="">
  <div class="container">
    <ToastPrime />
    <DialogPrime
      :header="$t('toastProgressSpinner')"
      v-model:visible="showProgressSpinner"
      :style="{ width: '15vw', height: '15vw' }"
    >
      <div class="card">
        <div class="flex flex-column card-container">
          <div class="flex align-items-center justify-content-center h-5rem m-4">
            <ProgressSpinner />
          </div>
        </div>
      </div>
    </DialogPrime>

    <div class="table">
      <div class="flex flex-row-reverse flex-wrap card-container">
        <div class="formgrid grid">
          <div class="field col-12 md:col-9">
            <p v-html="$t('home_p')" class="m-4 font-italic"></p>
          </div>
          <div class="field col-fixed md:col-1 m-2" style="width: 150px">
            <div v-if="false">
              <TemplateFileUploaderComponent />
            </div>
          </div>
          <div class="field col-fixed md:col-1 m-2" style="width: 120px">
            <ButtonPrime
              :label="$t('newShipBtn')"
              :style="{ width: '120px' }"
              class="p-button header_button"
              @click="newShip()"
            />
          </div>
        </div>
        <!--div class="flex align-items-center justify-content-center w-10rem h-4rem m-2">
          <ButtonPrime
            label="Economic"
            :style="{ width: '120px' }"
            class="p-button header_button"
            @click="economic()"
          />
        </div-->
      </div>
      <DataTablePrime
        :value="ships"
        v-model:expandedRows="expandedRows"
        dataKey="id"
        responsiveLayout="scroll"
        class="p-datatable-sm"
      >
        <ColumnPrime :expander="true" headerStyle="width: 2rem" />
        <ColumnPrime field="name" :header="$t('name')" sortable></ColumnPrime>
        <ColumnPrime field="shipTypeStr" :header="$t('shipType')" sortable></ColumnPrime>
        <ColumnPrime field="requiredEEXI" :header="$t('requiredEEXI')" sortable></ColumnPrime>
        <ColumnPrime field="attainedEEXI" :header="$t('attainedEEXI')" sortable></ColumnPrime>
        <ColumnPrime :header="$t('actions')" :style="{ width: '350px' }">
          <template #body="slotProps1">
            <ButtonPrime
              icon="pi pi-pencil"
              class="p-button actionButton"
              v-tooltip.top="$t('tooltipEditShip')"
              @click="editShip(slotProps1.data)"
            />
            <ButtonPrime
              icon="pi pi-plus-circle"
              v-tooltip.top="$t('tooltipNewConfig')"
              class="p-button actionButton"
              @click="dialogHandler(slotProps1.data)"
            />
            <ButtonPrime
              icon="pi pi-trash"
              class="p-button actionButton"
              v-tooltip.top="$t('tooltipDeleteShip')"
              @click="deleteHanlder(slotProps1.data)"
            />
            <ButtonPrime
              icon="pi pi-chart-bar"
              class="p-button actionButton"
              v-tooltip.top="$t('tooltipChart')"
              @click="chartCalculate(slotProps1.data)"
            />
            <ButtonPrime
              icon="pi pi-bolt"
              class="p-button actionButton"
              v-tooltip.top="'Carbon calculate'"
              @click="carbonCalc(slotProps1.data)"
            />
            <ButtonPrime
              icon="pi pi-book"
              class="p-button actionButton"
              v-tooltip.top="'Generate Documentation'"
              @click="generateDoc(slotProps1.data)"
            />
          </template>
        </ColumnPrime>
        <template #expansion="slotProps2">
          <div id="smallTableContainer" class="smallTableContainer">
            <h4>{{ $t("headerConf") }}:</h4>
            <DataTablePrime
              :value="slotProps2.data.configurations"
              responsiveLayout="scroll"
              class="p-datatable-sm inserted-table"
            >
              <ColumnPrime field="name" :header="$t('name')" sortable></ColumnPrime>
              <ColumnPrime field="description" :header="$t('description')" sortable></ColumnPrime>
              <ColumnPrime field="attainedEEXI" :header="$t('attainedEEXI')" sortable>
                <template #body="slotProps">
                  <div :class="stockClass(slotProps.data, slotProps2.data)">
                    {{ slotProps.data.attainedEEXI }}
                  </div>
                </template>
              </ColumnPrime>
              <ColumnPrime :header="$t('requiredEEXI')" sortable>
                <template #body="slotProps3">
                  <p>{{ getRequiredEEXIForConf(slotProps3.data) }}</p>
                </template>
              </ColumnPrime>
              <ColumnPrime :header="$t('actions')" :style="{ width: '300px' }">
                <template #body="slotProps2">
                  <ButtonPrime
                    icon="pi pi-pencil"
                    class="p-button actionButton"
                    v-tooltip.top="'Edit Configuration'"
                    @click="editConfiguration(slotProps2.data)"
                  />
                  <ButtonPrime
                    v-if="slotProps2.data.economicData"
                    icon="pi pi-money-bill"
                    class="p-button actionButton"
                    v-tooltip.top="$t('tooltipEditEco')"
                    @click="editEconomic(slotProps2.data)"
                  />
                  <ButtonPrime
                    v-if="!slotProps2.data.isBase"
                    icon="pi pi-circle-off"
                    v-tooltip.top="$t('tooltipSetBase')"
                    class="p-button actionButton"
                    @click="setBase(slotProps2.data)"
                  />
                  <ButtonPrime
                    v-else
                    :disabled="true"
                    icon="pi pi-check-square"
                    v-tooltip.top="$t('tooltipAlreadyBase')"
                    class="p-button actionButton"
                  />
                  <ButtonPrime
                    icon="pi pi-copy"
                    v-tooltip.top="$t('tooltipCloneConfig')"
                    class="p-button actionButton"
                    @click="copyConfigurationHandler(slotProps2.data)"
                  />
                  <ButtonPrime
                    icon="pi pi-trash"
                    class="p-button actionButton"
                    v-tooltip.top="$t('tooltipDeleteConfig')"
                    @click="deleteHanlder(slotProps2.data)"
                  />
                </template>
              </ColumnPrime>
            </DataTablePrime>
          </div>
        </template>
      </DataTablePrime>
    </div>
    <DialogPrime
      :header="$t('tooltipNewConfig')"
      v-model:visible="displayBasic"
      :breakpoints="{ '960px': '50vw', '640px': '50vw' }"
      :style="{ width: '50vw' }"
    >
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <InputTextPrime
            id="name"
            v-model="name"
            :placeholder="$t('name')"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div class="field col-12 md:col-6">
          <InputTextPrime
            id="name"
            v-model="description"
            :placeholder="$t('description')"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div class="field col-12 md:col-6"></div>
        <div class="field col-12 md:col-3">
          <ButtonPrime
            :label="$t('cancel')"
            class="p-button actionButton"
            v-tooltip.top="'Cancel create Configuration'"
            @click="cancelCreateConfiguration()"
          />
        </div>
        <div class="field col-12 md:col-3">
          <ButtonPrime
            :label="$t('create')"
            class="p-button actionButton"
            v-tooltip.top="'Create Configuration'"
            @click="createConfiguration()"
          />
        </div>
      </div>
    </DialogPrime>
    <DialogPrime
      :header="$t('dialogChart')"
      v-model:visible="displayChart"
      :breakpoints="{ '960px': '70vw', '640px': '70vw' }"
      :style="{ width: '50vw' }"
    >
      <DropdownPrime
        v-model="selectedChart"
        optionLabel="name"
        @change="chartSelection"
        :options="chartOptions"
        :placeholder="$t('dialogChartSelec')"
      />
      <ChartPrime type="bar" :data="chartData" />
      <ButtonPrime
        :label="$t('cancel')"
        class="p-button actionButton"
        v-tooltip.top="$t('cancel')"
        @click="displayChart = false"
      />
    </DialogPrime>

    <DialogPrime
      v-model:visible="deleteDialog"
      :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
      :style="{ width: '25vw' }"
    >
      <template #header>
        <h3 v-if="deleteShipDisplay == true">{{ $t("deleteShipDisplay") }} {{ itemToDelete.name }}?</h3>
        <h3 v-if="deleteConfigDisplay == true">{{ $t("deleteConfigDisplay") }} {{ itemToDelete.name }}?</h3>
      </template>
      <div class="formgrid grid">
        <ButtonPrime
          v-if="deleteShipDisplay == true"
          :label="$t('cancel')"
          class="p-button actionButton"
          v-tooltip.top="'Cancel'"
          @click="closeHandler()"
        />
        <ButtonPrime
          v-if="deleteShipDisplay == true"
          :label="$t('confirm')"
          class="p-button actionButton"
          v-tooltip.top="'Confirmation'"
          @click="deleteShip(this.itemToDelete)"
        />
        <ButtonPrime
          v-if="deleteConfigDisplay == true"
          :label="$t('cancel')"
          class="p-button actionButton"
          v-tooltip.top="'Cancel'"
          @click="closeHandler()"
        />
        <ButtonPrime
          v-if="deleteConfigDisplay == true"
          :label="$t('confirm')"
          class="p-button actionButton"
          v-tooltip.top="'Confirmation'"
          @click="deleteConfiguration(this.itemToDelete)"
        />
      </div>
    </DialogPrime>
  </div>
</template>
<script>
import router from "@/router/index";
import ShipService from "@/services/ShipService";
import EconomicService from "@/services/EconomicService";
import ConfigurationService from "@/services/ConfigurationService";
import store from "@/store/index";
import ParametricTableService from "@/services/ParametricTableService";
import TemplateFileUploaderComponent from "@/components/TemplateFileUploaderComponent";
// import EconomicService from "@/services/EconomicService";
import { ToastSeverity } from "primevue/api";
import utils from "@/utils/configuration/config.js";
import DocService from "@/services/DocService";



export default {
  setup() {
    const stockClass = (data1, data2) => {
      return [
        {
          in: data1.attainedEEXI < data2.requiredEEXI,
          out: data1.attainedEEXI > data2.requiredEEXI,
        },
      ];
    };

    return { stockClass };
  },
  data() {
    return {
      expandedRows: [],
      ships: [],
      users: [],
      showProgressSpinner: false,
      displayBasic: false,
      name: "",
      description: "",
      shipSelectedToCreateConfigurationId: undefined,
      configurationToClone: undefined,
      deleteShipDisplay: false,
      deleteConfigDisplay: false,
      deleteDialog: false,
      itemToDelete: {},
      chartData: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "#42A5F5",
            data: [],
          },
        ],
      },
      economicData: [],
      displayChart: false,
      chartOptions: [
        { name: "Annual Rentability", code: "AR" },
        { name: "Interest per year", code: "IPR" },
        { name: "Van per year", code: "VPY" },
        { name: "Ecoefficiency", code: "ECO" },
      ],
      selectedChart: {},
    };
  },
  components: {
    TemplateFileUploaderComponent,
  },
  computed: {
    languageState() {
      return store.getters.languageState;
    },
  },
  created() {
    console.log("ShipsTable - created");
    this.shipService = ShipService.getInstance();
    this.configurationService = ConfigurationService.getInstance();
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
    this.economicService = EconomicService.getInstance();
    store.commit("SET_LANGUAGE_STATE", store.getters.languageState);
     this.docService =  DocService.getInstance();
  },
  mounted() {
    this.shipService.getShips(this.ships);
    console.log("ShipsTable - mounted");
    console.log("ShipsTable - mounted", this.ships);
  },
  watch: {
    languageState(newVal) {
      if (newVal == "es") {
        this.chartOptions = [
          { name: "Rentabilidad anual", code: "AR" },
          { name: "Intereses anuales", code: "IPR" },
          { name: "Van cada año", code: "VPY" },
          { name: "Ecoeficiencia", code: "ECO" },
        ];
      } else if (newVal == "en") {
        this.chartOptions = [
          { name: "Annual Rentability", code: "AR" },
          { name: "Interest per year", code: "IPR" },
          { name: "Van per year", code: "VPY" },
          { name: "Ecoefficiency", code: "ECO" },
        ];
      }
    },
  },
  /*
  computed: {
    ships() {
      this.shipService.getShips(this.shipsAux);
      console.log("ShipsTableComponent", this.shipsAux);
      return this.shipsAux;
    },
  },
  */
  methods: {
    editShip(item) {
      let ship = {};

      this.ships.forEach((element) => {
        if (element.id == item.id) {
          ship = element;
        }
      });
      console.log("Este es el buque que vamos a editar", ship);
      this.shipService.selectedShip(ship);
      store.commit("SET_FORM_STATE", true);
      router.push({ name: "editShip", params: { id: ship.id } });
    },
    dialogHandler(item) {
      this.shipSelectedToCreateConfigurationId = item.id;
      this.configurationToClone = null;
      this.name = "";
      this.description = "";
      this.displayBasic = true;
    },
    copyConfigurationHandler(data) {
      console.log("copyConfigurationHandler", data);

      var shipFound = null;
      this.ships.forEach((ship) => {
        ship.configurations.forEach((configuration) => {
          if (configuration.id === data.id) {
            shipFound = ship;
          }
        });
      });

      if (shipFound) {
        this.shipSelectedToCreateConfigurationId = shipFound.id;
        this.configurationToClone = data;
        this.name = data.name + " (2)";
        this.description = data.description;
        this.displayBasic = true;
      }
    },
    createConfiguration() {
      this.displayBasic = false;

      var errors = "";
      if (this.configurationToClone) {
        console.log("Vamos a clonar la configuración", this.configurationToClone.name);
        errors = this.shipService.configurationService.cloneConfiguration(
          this.configurationToClone,
          this.shipSelectedToCreateConfigurationId,
          this.name,
          this.description
        );
      } else {
        console.log("Vamos a crear una nueva configuración", this.name);
        errors = this.shipService.configurationService.createConfiguration(
          this.shipSelectedToCreateConfigurationId,
          this.name,
          this.description,
          false
        );
      }

      if (errors != "") {
        this.showToast(false, "Error creando configuración: " + errors);
      } else {
        this.showToast(true, "Configuración creada correctamente");
        this.start_spinner();
      }
    },
    cancelCreateConfiguration() {
      this.displayBasic = false;
    },
    getRequiredEEXIForConf(configuration) {
      console.log("getRequiredEEXIForConf", configuration);

      const ship = this.findShipForConfiguration(configuration);

      var valueAppendix = "";
      var value = 0;
      if (configuration.modified_required_EEXI) {
        value = configuration.modified_required_EEXI;
        valueAppendix = " (modified)";
      } else {
        value = ship.requiredEEXI;
        valueAppendix = " (default)";
      }
      return "" + value + valueAppendix;
    },
    editConfiguration(configurationItem) {
      console.log("editConfiguration", configurationItem);

      const ship = this.findShipForConfiguration(configurationItem);

      this.shipService.configurationService.selectedConfiguration(configurationItem);
      this.shipService.selectedShip(ship);
      store.commit("SET_FORM_STATE", false);
      router.push({ name: "editConfiguration", params: { id: ship.id } });
    },
    editEconomic(configurationItem) {
      console.log("editEconomic", configurationItem);

      const ship = this.findShipForConfiguration(configurationItem);

      this.shipService.configurationService.selectedConfiguration(configurationItem);
      this.shipService.selectedShip(ship);
      this.configurationService.selectedConfiguration(configurationItem);
      router.push({ name: "editEconomic", params: { id: ship.id } });
    },
    deleteShip(shipItem) {
      console.log("deleteShip", shipItem);
      this.deleteShipDisplay = false;
      this.deleteDialog = false;
      this.shipService.deleteShip(shipItem.id);

      this.start_spinner();
    },
    deleteConfiguration(configurationItem) {
      console.log("deleteConfiguration", configurationItem);
      this.deleteConfigDisplay = false;
      this.deleteDialog = false;
      const ship = this.findShipForConfiguration(configurationItem);
      this.shipService.configurationService.deleteConfiguration(ship.id, configurationItem.id);

      this.start_spinner();
    },
    start_spinner() {
      this.expandedRowsStored = this.expandedRows;
      this.expandedRows = null;
      this.showProgressSpinner = true;

      setTimeout(this.stopSpinner, 1000);
    },
    stopSpinner() {
      this.showProgressSpinner = false;
      this.expandedRows = this.expandedRowsStored;

      this.ships = [];
      this.shipService.getShips(this.ships);
    },
    setBase(configurationItem) {
      console.log("setBase", configurationItem);
      const ship = this.findShipForConfiguration(configurationItem);
      const errors = this.shipService.configurationService.setConfigurationAsBase(ship.id, configurationItem.id, true);

      if (errors != "") {
        this.showToast(false, "Error estableciendo configuración como base: " + errors);
      } else {
        this.showToast(true, "Configuración establecida como base correctamente");
        this.start_spinner();
      }
    },
    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
    newShip() {
      this.shipService.selectedShip({});
      router.push({ name: "editShip", params: { id: "newShip" } });
    },
    findShipForConfiguration(configurationItem) {
      let ship = {};
      this.ships.forEach((element) => {
        console.log(element, configurationItem);
        element.configurations.forEach((configurationElement) => {
          if (configurationElement.id == configurationItem.id) {
            ship = element;
            console.log("encontrado", ship);
          }
        });
      });
      return ship;
    },
    deleteHanlder(item) {
      Object.prototype.hasOwnProperty.call(item, "configurations")
        ? (this.deleteShipDisplay = true)
        : (this.deleteConfigDisplay = true);
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    closeHandler() {
      this.deleteDialog = false;
      this.deleteShipDisplay = false;
      this.deleteConfigDisplay = false;
    },
    chartCalculate(item) {
      this.displayChart = true;
      console.log(item);

      let ecoData = [];
      item.configurations.forEach((element) => {
        if (element.economicData.ecoEfficiency != undefined && element.economicData.ecoEfficiency != null) {
          ecoData.push({
            name: element.name,
            annualRentability: element.economicData.annualRentability,
            ecoEfficiency: element.economicData.ecoEfficiency,
            interestPerYear: element.economicData.interestPerYear,
            vanPerYear: element.economicData.vanPerYear,
          });
        }
      });

      this.economicData = ecoData;
    },
    chartSelection(event) {
      console.log(event.value);
      this.chartData.datasets = [];
      let colors = ["#42A5F5", "#FF5733", "#43CF3A", "#FFD700", "#3B39D6", "#ADD8E6", "#9f0e0e", "#ab1c80", "#A0522D"];
      let i = 0;
      this.economicData.forEach((element) => {
        switch (event.value.code) {
          case "AR":
            this.chartData.datasets.push({
              label: element.name,
              backgroundColor: colors[i],
              data: element.annualRentability,
            });
            break;
          case "IPR":
            this.chartData.datasets.push({
              label: element.name,
              backgroundColor: colors[i],
              data: element.interestPerYear,
            });
            break;
          case "VPY":
            this.chartData.datasets.push({
              label: element.name,
              backgroundColor: colors[i],
              data: element.vanPerYear,
            });
            break;
          case "ECO":
            this.chartData.datasets.push({
              label: element.name,
              backgroundColor: colors[i],
              data: element.ecoEfficiency,
            });
            break;
        }
        i++;
      });
      if (this.economicData && this.economicData.length > 0 && this.economicData[0].annualRentability) {
        this.chartData.labels = Array.from(Array(this.economicData[0].annualRentability.length).keys());
      } else {
        console.log("labels con error", this.economicData);
      }

      console.log(this.chartData);
    },
    carbonCalc(ShipItem) {
      console.log("carbonCalc.-", ShipItem);

      this.shipService.selectedShip(ShipItem);
      router.push({ name: "CarbonView", params: { id: ShipItem.id } });
    },

    generateDoc(ship){
      this.docService.createDoc({ship: ship});
    }
  },
};
</script>
<style scoped>
.container {
  display: table;
  width: 100%;
}

#smallTableContainer {
  width: 80%;
  padding-left: 100px;
}

.tableContainer {
  display: table-cell;
}

.table {
  padding-bottom: 5%;
}

.inserted-table {
  padding-bottom: 5%;
}

.actionButton {
  margin: 2px !important;
}

.out {
  font-weight: 700;
  color: #ff5252;
}
.in {
  font-weight: 700;
  color: #66bb6a;
}
</style>
